var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoOpTiMTaglet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 236.53 53.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1-2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 236.53,
    height: 53.85,
    fill: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.41,13.52h-2.49c-3.54,0-6.4,2.65-6.4,5.91v15c0,3.26,2.87,5.91,6.4,5.91h2.49c3.53,0,6.4-2.65,6.4-5.91v-15c0-3.26-2.87-5.91-6.4-5.91M22.16,35.26c0,.47-.37.86-.83.86h-.32c-.46,0-.83-.38-.83-.86v-16.67c0-.47.37-.86.83-.86h.32c.46,0,.83.38.83.86v16.67Z",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.67,13.87h-9.9v26.12h6.71v-10.39h3.19c2.55,0,4.61-2.18,4.61-4.87v-6c0-2.69-2.06-4.87-4.61-4.87M40.69,23.07c0,1.02-.79,1.85-1.75,1.85h-.46v-6.78h.46c.96,0,1.75.83,1.75,1.84v3.09Z",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.58,
    y: 13.87,
    width: 6.38,
    height: 5.45,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.58,
    y: 20.5,
    width: 6.38,
    height: 19.5,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.62 13.87 48.31 13.87 48.31 19.11 52.18 19.11 52.18 39.91 58.55 39.91 58.55 19.11 62.62 19.11 62.62 13.87",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.93 13.97 84.46 25.64 82.76 13.97 74.91 13.97 74.91 39.91 80.34 39.91 80.34 23.07 82.61 39.91 86.31 39.91 88.48 23.07 88.48 39.91 93.77 39.91 93.77 13.97 85.93 13.97",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M97.97,14.29c1.27,0,2.3,1.03,2.3,2.3s-1.03,2.3-2.3,2.3-2.3-1.03-2.3-2.3,1.03-2.3,2.3-2.3M97.97,13.87c-1.5,0-2.72,1.22-2.72,2.72s1.22,2.72,2.72,2.72,2.72-1.22,2.72-2.72-1.22-2.72-2.72-2.72h0Z",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.15,15c.38,0,.66.08.84.23.18.15.27.38.27.69,0,.29-.08.5-.24.63-.16.13-.36.21-.6.24l.91,1.41h-.53l-.87-1.37h-.53v1.37h-.5v-3.19h1.23ZM97.93,16.42c.11,0,.22,0,.32-.01.1,0,.19-.03.27-.06.08-.03.14-.09.19-.16.05-.07.07-.17.07-.3,0-.11-.02-.19-.06-.26-.04-.06-.09-.11-.16-.15-.07-.03-.14-.06-.23-.07-.09-.01-.17-.02-.25-.02h-.66v1.01h.52Z",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M123.7,10.74v29.2h-1.94V10.74h-10.08v-1.75h22.1v1.75h-10.08Z",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.28,40.18c-.44.12-.87.16-1.31.16-1.83,0-3.09-1.11-3.09-3.61-1.11,2.18-5,3.61-8.73,3.61-4.52,0-6.47-1.86-6.63-5.36v-.36c0-4.32,3.37-6.15,7.54-7.14,3.29-.79,7.54-1.9,7.54-4.05,0-3.05-2.46-4.21-6.43-4.21-2.78,0-6.19,1.59-7.34,3.85l-1.03-1.47c1.47-2.3,4.96-3.89,8.33-3.89,5,0,8.33,1.47,8.33,5.95v12.42c0,1.83.67,2.7,1.9,2.7.36,0,.79-.08,1.27-.24l-.36,1.63ZM151.8,25.94c-1.23,1.31-4.13,2.3-7.34,3.09-3.49.87-6.19,2.14-6.19,5.51v.44c.16,2.46,1.63,3.77,4.76,3.77s7.93-1.43,8.77-4.8v-8.01Z",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.19,47.99c-2.82,0-5.99-.56-7.93-1.35l-.2-2.14c2.42,1.19,5.32,1.86,8.17,1.86,4.48,0,7.9-2.22,7.9-6.62v-4.48c-.91,2.5-3.97,4.29-7.26,4.29-5.67,0-9.72-3.49-9.72-10.91s4.05-10.91,9.72-10.91c3.49,0,5.99,1.43,7.14,3.45l.36-3.05h1.43v21.82c0,5.12-3.61,8.05-9.6,8.05ZM176.16,23.75c-1.67-3.09-4.17-4.48-7.3-4.48-4.32,0-8.05,2.7-8.05,9.36s3.73,9.36,8.05,9.36c3.85,0,7.3-3.09,7.3-6.67v-7.58Z",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.22,39.94V9h1.83v30.94h-1.83Z",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.99,30.46c.4,5.12,3.89,8.29,8.41,8.29,3.49,0,6.67-2.02,7.97-5.4l1.11,1.55c-1.63,3.17-4.76,5.43-9.08,5.43-6.07,0-10.12-4.4-10.12-11.31s4.05-11.31,10-11.31,9.32,3.93,9.4,10.35l-17.69,2.38ZM201.28,19.27c-4.92,0-8.37,3.53-8.37,9.6l15.87-2.14c-.16-4.44-3.33-7.46-7.5-7.46Z",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.06,40.34c-4.72,0-6.27-1.07-6.27-5.2v-15.43h-3.05v-1.59h3.05v-6.86h1.71v6.86h3.97v1.59h-3.97v15.27c0,3.33.71,3.73,5.24,3.73l-.67,1.63Z",
    strokeWidth: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOpTiMTaglet);
export default __webpack_public_path__ + "static/media/logo_OPTiM-taglet.e4dc1e72b825fdc6eb88e91e46e6fc37.svg";
export { ForwardRef as ReactComponent };